import React from 'react'
import { connect } from 'react-redux'
import { Grid, Segment } from 'semantic-ui-react'
import { LKTextArea } from 'loankeeper-common/components'
import { withRouter } from 'react-router-dom'
import { updateComments } from '../../../../store/loan'
//@ts-ignore
import { FlexSegment, FakeInput, GridContainer, ComponentContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKButton from 'shared/LKButton'
import translate from '../../translator'
import { actions as DetailsContainerActions } from '../../../DetailsContainer'

import { LoanAdditionalInfoProps, LoanAdditionalInfoState } from '../../types.LoanDetails'
import { UpdateCommentsParams } from '@lk/api'

@withRouter
//@ts-ignore
@connect(undefined, (dispatch) => ({
  updateComments: (params: UpdateCommentsParams) =>
  //@ts-ignore
    dispatch(updateComments(params)).then(() =>
      dispatch(
        DetailsContainerActions.fetchPage({
          type: 'Loan',
          ID: params.LoanID,
          hash: params.HashSum_LoanID_,
          page: 'base',
        }),
      ),
    ),
}))
class LoanAdditionalInfo extends React.Component<LoanAdditionalInfoProps, LoanAdditionalInfoState>  {
  state = this.getInitialState(this.props)

  getInitialState({ data }) {
    const { Comment, CField1, CField2, CField3, CField4 } = data
    return { Comment, CField1, CField2, CField3, CField4, updateCommentsButtonPending: false }
  }

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    this.setState({ [name]: value })
  }

  handleSubmit = (event: SubmitEvent) => {
    event.preventDefault()

    const { hash } = this.props.match.params
    const { Comment, CField1, CField2, CField3, CField4 } = this.state

    this.setState({
      updateCommentsButtonPending: true,
    })

    this.props
      .updateComments({
        LoanID: this.props.data.ID,
        HashSum_LoanID_: hash,
        Comment,
        CField1,
        CField2,
        CField3,
        CField4,
      })
      .then(() => {
        this.setState({
          updateCommentsButtonPending: false,
        })
      })
  }

  render() {
    const { data } = this.props
    const { Comment, CField1, CField2, CField3, CField4, updateCommentsButtonPending } = this.state
    return (
      <FlexSegment>
        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={3} verticalAlign="middle" textAlign="right">
                {translate('lbl_loan_comment')}
              </Grid.Column>

              <Grid.Column width={13}>
                <ComponentContainer textArea>
                  <LKTextArea name="Comment" value={Comment} onChange={this.handleInputChange} />
                </ComponentContainer>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={3} verticalAlign="middle" textAlign="right">
                {translate('lbl_loan_cfield')}
              </Grid.Column>

              <Grid.Column width={5}>
                <ComponentContainer textArea>
                  <LKTextArea name="CField1" value={CField1} onChange={this.handleInputChange} />
                </ComponentContainer>
              </Grid.Column>

              <Grid.Column width={3} verticalAlign="middle" textAlign="right">
                {translate('lbl_loan_cfield2')}
              </Grid.Column>

              <Grid.Column width={5}>
                <ComponentContainer textArea>
                  <LKTextArea name="CField2" value={CField2} onChange={this.handleInputChange} />
                </ComponentContainer>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={3} verticalAlign="middle" textAlign="right">
                {translate('lbl_loan_cfield3')}
              </Grid.Column>

              <Grid.Column width={5}>
                <ComponentContainer textArea>
                  <LKTextArea name="CField3" value={CField3} onChange={this.handleInputChange} />
                </ComponentContainer>
              </Grid.Column>

              <Grid.Column width={3} verticalAlign="middle" textAlign="right">
                {translate('lbl_loan_cfield4')}
              </Grid.Column>

              <Grid.Column width={5}>
                <ComponentContainer textArea>
                  <LKTextArea name="CField4" value={CField4} onChange={this.handleInputChange} />
                </ComponentContainer>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column floated="right" width={2} textAlign="right">
                <LKButton
                  alias="edit"
                  onClick={this.handleSubmit}
                  loading={updateCommentsButtonPending}
                  disabled={updateCommentsButtonPending}
                  fluid
                  permission="EDIT_LOAN_COMMENTS"
                >
                  {translate('cmd_edit')}
                </LKButton>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={3} />

              <Grid.Column width={3}>
                <FakeInput>
                  <Segment>{translate('pan_lorank_l')}</Segment>
                </FakeInput>
              </Grid.Column>

              <Grid.Column width={2}>
                <FakeInput>
                  <Segment>{data.LORank}</Segment>
                </FakeInput>
              </Grid.Column>

              <Grid.Column width={3} />

              <Grid.Column width={3}>
                <FakeInput>
                  <Segment>{translate('pan_apprank_l')}</Segment>
                </FakeInput>
              </Grid.Column>

              <Grid.Column width={2}>
                <FakeInput>
                  <Segment>{data.AppRank}</Segment>
                </FakeInput>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>
      </FlexSegment>
    )
  }
}

export default LoanAdditionalInfo
